import { types } from 'mobx-state-tree'
import { WithLatLngModel } from './WithLatLng'

export const CenterLocationModel = 
  WithLatLngModel.named('CenterLocationModel')
  .props({
    center_id: types.number, 
  })
  .views((self) => ({
    get centerId(): typeof self.center_id {
      return self.center_id
    },
  }))